<template>
  <section v-if="enabled" v-show="showBar" class="announcement-bar py-3 py-lg-2 py-xl-0 text-light">
    <div class="container-xl">
      <div class="row align-items-lg-center justify-content-between">
        <div class="col-lg-1" v-if="!button.enable"></div>
        <div class="col-10 align-items-center" :class="button.enable ? 'd-xl-flex justify-content-between' : 'd-md-flex justify-content-lg-center'">
          <p class="mb-0 py-xl-1" :class="button.enable ? 'text-start' : 'text-lg-center'" v-html="text"></p>
          <DefaultButton v-if="button.enable" class="btn-light mt-3 mt-md-2 mt-xl-0 ml-xl-1" :link="button.link" :type="button.type" :buttonText="button.label" :aria-label="button.label" />
        </div>
        <div class="col-1 d-flex justify-content-end align-items-start align-items-lg-center">
          <button type="button" class="btn btn-close" @click="closeBar" aria-label="Close">
            <b-icon icon="x" />
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import DefaultButton from 'building-blocks/components/DefaultElements/DefaultButton.vue';
  import BIcon from 'building-blocks/components/BIcon.vue';

  export default {
    components: {
      DefaultButton,
      BIcon
    },
    props: {},
    data() {
      return {
        showBar: false
      }
    },
    watch: {
      $route(route) {
        if (route.path.search('/checkout/confirmation') !== -1) {
          this.showBar = false; // Hide the announcement bar on checkout/confirmation page
        } else if (route.path.search('/checkout') === -1 && this.mgnlData?.securityGuard.includes('checkout') && this.mgnlData?.securityGuard.length === 1) {
          this.showBar = false; // Show the announcement bar only on checkout pages
        } else if (route.path.search('/checkout') !== -1 && !this.mgnlData?.securityGuard.includes('checkout')) {
          this.showBar = false; // Hide the announcement bar on checkout pages
        } else if (this.mgnlData?.securityGuard.includes('loggedin') && !this.mgnlData?.securityGuard.includes('loggedout') && !this.$store.state.user.loggedIn) {
          this.showBar = false; // Hide the announcement bar for logged-out users if security guard is set
        } else if (this.mgnlData?.securityGuard.includes('loggedout') && this.mgnlData?.securityGuard.length === 1 && this.$store.state.user.loggedIn) {
          this.showBar = false; // Hide the announcement bar for logged-in users if security guard is set
        } else {
          const storedValue = localStorage.getItem('show-announcement-bar');
          this.showBar = storedValue !== null ? storedValue === 'true' : true;
        }
      }
    },
    methods: {
      closeBar() {
        this.showBar = false;
        localStorage.setItem('show-announcement-bar', 'false');
      },
      getButtonHref(button) {
        return button.type?.field === 'url' ? button.type?.url : (button.type?.field === 'link' ? this.removeSiteName(button.type?.link) : null);
      },
      removeSiteName(link) {
        if (link) {
          const siteName = link.substr(0, link.lastIndexOf("/"));
          return link.replace(siteName, '');
        }
      }
    },
    computed: {
      mgnlData() {
        return this.$store.state.pages.additionalOptions.announcementBar;
      },
      enabled() {
        return this.mgnlData?.enable || false;
      },
      text() {
        return this.mgnlData?.text;
      },
      button() {
        const link = this.getButtonHref(this.mgnlData.button);
        return {
          enable: this.mgnlData?.button.enable === 'true' && link,
          label: this.mgnlData?.button.label,
          link: link,
          type: this.mgnlData?.button.type?.field,
        }
      },
    },
    created() {
      const storedValue = localStorage.getItem('show-announcement-bar');
      if(!storedValue) {
        localStorage.setItem('show-announcement-bar', 'true'); // Set default value if not present
        this.showBar = true;
      }
    }
  };
</script>

<style lang="scss" scoped>
  .announcement-bar {
    transition: all 0.5s;
    background-color: var(--gray-800);
    p {
      line-height: 1.25s !important;
    }
    .btn-light {
      color: var(--gray-800) !important;
      padding: 0.15rem 0.75rem;
      font-size: .95rem;

      @include media-breakpoint-down(md) {
        font-size: .8rem;
      }
    }
    .btn-close {
      background-color: transparent;
      box-shadow: none;
      color: inherit;
      padding: .5rem .75rem;

      .b-icon {
        width: 1.5rem;
        height: 1.5rem;
      }

      @include media-breakpoint-down(sm) {
        margin-top: -.75rem;
        margin-right: -.5rem;
      }
    }
  }
</style>